import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import moment from 'moment';
import { orderBy } from 'natural-orderby';

import { config } from '../../../../config/index';
import { GET, PUT, newFetch, DELETE } from '../../../../helpers/fetch';

import LayoutContext from '../../../../store/Layout/contexts';
import Searchbar from '../../../../components/Searchbar';
import Upload from '../../../../components/Input/Upload';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import AppContext from '../../../../store/App/contexts';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
const { SERVER_URL } = config;

const EditEvent = ({
  history,
  match: {
    params: { event_id },
  },
}) => {
  const type = localStorage.getItem('type');
  const {
    fetchClientsOptions,
    client_options,
    selectedClientID,
    clientFilterHandler,
  } = React.useContext(AppContext);
  const [clientName, setClientName] = useState('');
  const [client, setClient] = useState('');
  const [origClient, setOrigClient] = useState('');
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const siteID = parseInt(localStorage.getItem('site'), 10);
  const [event, setEvent] = useState([]);
  const [clients, setClients] = useState([]);
  const [sites, setSites] = useState([]);
  const [associates, setAssociates] = useState([]);
  const [filteredAssociates, setFilteredAssociates] = useState([]);
  const [selectedAssociates, setSelectedAssociates] = useState([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [venue, setVenue] = useState('');
  const [dateTime, setDateTime] = useState('');
  const [duration, setDuration] = useState('');
  const [url, setUrl] = useState('');
  const [contactInfo, setContactInfo] = useState('');
  const [images, setImages] = useState([]);
  const [files, setFiles] = useState([]);

  const [showFilter, setShowFilter] = useState(false);
  const [activeClient, setActiveClient] = useState(null);
  const [activeSite, setActiveSite] = useState(null);

  const fetchEvent = async () => {
    let api_path = `/event/${event_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let eventData = response.data;
      let associateIdArr = eventData.associates.map(
        (associate) => associate.event_associate.associate_id
      );

      setEvent(eventData);
      setTitle(eventData.title);
      setDescription(eventData.description);
      setVenue(eventData.event_venue);
      setDateTime(moment(eventData.date).format('YYYY-MM-DDThh:mm'));
      setDuration(eventData.duration);
      setImages(eventData.images);
      setUrl(eventData.url);
      setContactInfo(eventData.contact);
      setSelectedAssociates(associateIdArr);
      setClient(eventData.client_id);
      setOrigClient(eventData.client_id);
      handleSetClientName(eventData.client_id);
    }
  };

  const fetchClients = async () => {
    let api_path = `/client`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let clientsData = response.data;
      let sorted = orderBy(clientsData, [(client) => client.name]);
      setClients(sorted);
    }
  };

  const fetchSites = async (client_id) => {
    let api_path = `/client/${client_id}/site`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let sitesData = response.data;
      let sorted = orderBy(sitesData, [(site) => site.name]);
      setSites(sorted);
    }
  };

  const fetchAssociates = async () => {
    let api_path = `/associate/site/${siteID}/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let associatesData = response.data;
      let sorted = orderBy(associatesData, [
        (associate) => `${associate.first_name} ${associate.last_name}`,
      ]);

      setAssociates(sorted);
      setFilteredAssociates(sorted);
    }
  };

  const handleSearch = (e) => {
    let filtered = [...associates].filter((associate) => {
      let name = `${associate.first_name} ${associate.last_name}`;
      return name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1;
    });

    setFilteredAssociates(filtered);
  };

  const handleClearFilter = () => {
    setActiveClient(null);
    setActiveSite(null);
    setFilteredAssociates(associates);
  };

  const handleApplyFilter = async () => {
    if (!activeClient) {
      ToastUtil.error('Please select a Client.');
    }

    if (!activeSite) {
      ToastUtil.error('Please select site.');
      return false;
    }
    let filtered = [...associates].filter((associate) =>
      associate.sites.some((site) => site.id === activeSite.id)
    );

    setFilteredAssociates(filtered);
  };

  const handleSelectRemoveAssociate = (associate_id) => {
    if (selectedAssociates.some((id) => id === associate_id)) {
      setSelectedAssociates(
        [...selectedAssociates].filter((id) => id !== associate_id)
      );
    } else {
      setSelectedAssociates([...selectedAssociates, associate_id]);
    }
  };

  const handleSelectAll = (e) => {
    e.preventDefault();
    setSelectedAssociates(
      JSON.parse(JSON.stringify([...filteredAssociates])).map(
        (associate) => associate.id
      )
    );
  };

  const handleRemoveAll = (e) => {
    e.preventDefault();
    setSelectedAssociates([]);
  };

  const handleDeleteImage = async (image_id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this image?'
      )
    ) {
      let api_path = `/event/image/${image_id}`;
      let response = await newFetch(DELETE, api_path);

      ToastUtil.success(response.message);
      response.success && fetchEvent();
    }
  };

  const handleDiscard = () => {
    setTitle('');
    setDescription('');
    setSelectedAssociates([]);
    setFiles([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let addtnl_message = ``;

    if (selectedClientID != 0 && origClient !== parseInt(selectedClientID))
      addtnl_message = `Client has been updated. `;

    if (!client || client == 0) {
      ToastUtil.error('Please select a Client!');
      return false;
    }

    if (!title) {
      ToastUtil.error('Please enter title.');
      return false;
    }

    if (selectedAssociates.length === 0) {
      ToastUtil.error('Please select recipients.');
      return false;
    }

    if (
      await AlertService.confirm(
        '',
        `${addtnl_message}Are you sure you want to edit this Event?`
      )
    ) {
      let formData = new FormData();

      formData.append('title', title);
      formData.append('description', description);
      formData.append('associates', JSON.stringify(selectedAssociates));
      formData.append('event_venue', venue);
      formData.append('date', moment(dateTime).format('YYYY-MM-DD HH:mm'));
      formData.append('duration', duration);
      formData.append('contact', contactInfo);
      formData.append('url', url);
      formData.append('client_id', client);

      for (let file of files) {
        formData.append('files[]', file);
      }

      let api_path = `/event/${event_id}`;
      let response = await newFetch(PUT, api_path, formData, 'multi');

      ToastUtil.success(response.message);
      response.success && history.push(`/events/event/${event_id}`);
    }
  };

  const handleSetClientName = (id) => {
    setClientName(
      client_options &&
        client_options.find((clnt) => clnt.id === parseInt(id))?.name
    );
  };

  useEffect(() => {
    fetchEvent();
    fetchClients();
    fetchAssociates();
    fetchClientsOptions(type);
  }, []);

  useEffect(() => {
    fetchAssociates();
  }, [clientID, siteID]);

  useEffect(() => {
    activeClient ? fetchSites(activeClient.id) : setSites([]);
  }, [activeClient]);

  useEffect(() => {
    if (client_options && !clientName) {
      setClient(selectedClientID);
      handleSetClientName(selectedClientID);
    }
  }, [client_options]);

  useEffect(() => {
    if (client != selectedClientID) {
      setClient(selectedClientID);
      handleSetClientName(selectedClientID);
    }
  }, [selectedClientID]);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem', marginBottom: '6rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to={`/events/event/${event_id}`}
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div style={{ color: '#5156BE' }}>
                <i className="fas fa-chevron-left pe-2"></i>Back to Events
              </div>
            </NavLink>
            <div className="pt-4">
              <h5>Edit Event</h5>
            </div>
          </div>
          <div
            className="d-flex"
            style={{
              marginTop: '2rem',
              marginLeft: '3rem',
              marginRight: '3rem',
            }}
          >
            <div className="flex-grow-1">
              <div className="rounded adjust-shadow bg-white">
                <div className="p-4">
                  <div className="d-flex flex-column">
                    <div className="mb-2 py-2">
                      <label htmlFor="eventClient">
                        <strong>Client</strong>
                      </label>
                      <p
                        style={{
                          fontSize: 20,
                          color: '#595b5f',
                          fontWeight: 500,
                          paddingLeft: 8,
                        }}
                      >
                        {client && clientName}
                      </p>
                    </div>
                    <div className="mb-2 py-2">
                      <label htmlFor="eventTitle">
                        <strong>Event Title</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-2 adjust-fs"
                        id="eventTitle"
                        placeholder="Event Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                    <div className="mb-2 py-2">
                      <label htmlFor="eventDescription">
                        <strong>Description</strong>
                      </label>
                      <textarea
                        className="form-control adjust-fs mt-2"
                        id="eventDescription"
                        rows="8"
                        style={{ resize: 'none' }}
                        placeholder="Event Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                    <div className="mb-2 py-2">
                      <label htmlFor="eventVenue">
                        <strong>Event Venue</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control adjust-fs mt-2"
                        id="eventVenue"
                        placeholder="Event Venue"
                        value={venue}
                        onChange={(e) => setVenue(e.target.value)}
                      />
                    </div>
                    <div className="mb-2 py-2">
                      <label htmlFor="eventDateTime">
                        <strong>Date and Timing</strong>
                      </label>
                      <input
                        type="datetime-local"
                        className="form-control w-25 adjust-fs mt-2"
                        id="eventDateTime"
                        placeholder="Event Date and Time"
                        value={dateTime}
                        onChange={(e) => setDateTime(e.target.value)}
                      />
                    </div>
                    <div className="mb-2 py-2">
                      <label htmlFor="eventDuration">
                        <strong>Duration (Hour)</strong>
                      </label>
                      <input
                        type="number"
                        min={1}
                        className="form-control w-25 adjust-fs mt-2"
                        id="eventDuration"
                        placeholder="Event Duration"
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                      />
                    </div>
                    <div className="mb-2 py-2">
                      <label htmlFor="eventURL">
                        <strong>Event URL</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control w-50 adjust-fs mt-2"
                        id="eventURL"
                        placeholder="Event URL"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                      />
                    </div>
                    <div className="mb-2 py-2">
                      <label htmlFor="eventContactInfo">
                        <strong>Contact Info</strong>
                      </label>
                      <input
                        type="text"
                        className="form-control w-25 adjust-fs mt-2"
                        id="eventContactInfo"
                        placeholder="Event Contact Information"
                        value={contactInfo}
                        onChange={(e) => setContactInfo(e.target.value)}
                      />
                    </div>
                    <div className="mb-2 py-2">
                      <label htmlFor="eventUpload" className="mb-2">
                        <strong>Upload Files</strong>
                      </label>
                      {images.length > 0 && (
                        <>
                          <div className="row me-0 ms-0">
                            {images.map((image) => (
                              <div
                                className="img-responsive col-3 border rounded pe-0 ps-0 p-2"
                                style={{
                                  position: 'relative',
                                  background: `url(${`${SERVER_URL}/${image.url}`}) no-repeat center center`,
                                  backgroundSize: 'cover',
                                  height: '200px',
                                }}
                                key={image.id}
                              >
                                <i
                                  className="fas fa-times-circle"
                                  style={{
                                    float: 'right',
                                    color: '#fff',
                                    cursor: 'pointer',
                                    fontSize: '1.25rem',
                                  }}
                                  onClick={() => handleDeleteImage(image.id)}
                                ></i>
                              </div>
                            ))}
                          </div>
                          <hr />
                        </>
                      )}
                      <Upload
                        files={files}
                        setFiles={setFiles}
                        accept={
                          'application/pdf, image/jpg, image/jpeg, image/png'
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="d-flex flex-column"
              style={{ width: '250px', marginLeft: '2rem' }}
            >
              <strong>Select Recipients</strong>
              <Searchbar
                search={(e) => handleSearch(e)}
                placeholder="Search associates"
                width="100%"
              />

              {/* <div className="d-flex flex-column">
                <button
                  className="btn btn-outline-brand"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  Filter
                </button>
                <div
                  className="rounded bg-white shadow py-2 px-3 mt-2"
                  hidden={!showFilter}
                >
                  <div className="mb-2 pb-1">
                    <label htmlFor="filterClient">
                      <strong>Select Client</strong>
                    </label>
                    <select
                      name="filterClient"
                      id="filterClient"
                      className="form-select"
                      value={activeClient ? activeClient.id : 0}
                      onChange={({ target: { value } }) =>
                        setActiveClient(
                          clients.find(
                            (client) => client.id === parseInt(value)
                          )
                            ? clients.find(
                                (client) => client.id === parseInt(value)
                              )
                            : null
                        )
                      }
                    >
                      <option value="0">Select</option>
                      {clients.length > 0 &&
                        clients.map((client) => (
                          <option key={client.id} value={client.id}>
                            {client.name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="mb-2 pb-1">
                    <label htmlFor="filterSite">
                      <strong>Select Site</strong>
                    </label>
                    <select
                      name="filterSite"
                      id="filterSite"
                      className="form-select"
                      value={activeSite ? activeSite.id : 0}
                      onChange={({ target: { value } }) =>
                        setActiveSite(
                          sites.find((site) => site.id === parseInt(value))
                            ? sites.find((site) => site.id === parseInt(value))
                            : null
                        )
                      }
                    >
                      <option value="0">Select</option>
                      {sites.length > 0 &&
                        sites.map((site) => (
                          <option key={site.id} value={site.id}>
                            {site.name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="mt-2 py-2 border-top d-flex justify-content-between">
                    <div
                      className="text-muted"
                      style={{ fontSize: '0.8rem' }}
                      onClick={() => handleClearFilter()}
                    >
                      CLEAR FILTER
                    </div>
                    <div
                      className="text-brand"
                      style={{ fontSize: '0.8rem' }}
                      onClick={() => handleApplyFilter()}
                    >
                      ADD
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="d-flex justify-content-between mt-3">
                <p>Associates ({filteredAssociates.length})</p>
                {selectedAssociates.length === 0 ? (
                  <a
                    href="javascipt:void(0)"
                    onClick={(e) => handleSelectAll(e)}
                  >
                    Select All
                  </a>
                ) : selectedAssociates.length === filteredAssociates.length ? (
                  <a
                    href="javascipt:void(0)"
                    onClick={(e) => handleRemoveAll(e)}
                  >
                    Remove All
                  </a>
                ) : (
                  <a
                    href="javascipt:void(0)"
                    onClick={(e) => handleRemoveAll(e)}
                  >
                    Remove ({selectedAssociates.length})
                  </a>
                )}
              </div>
              <div
                style={{ maxHeight: '450px', overflowY: 'auto' }}
                className="px-2 rounded bg-white"
              >
                {filteredAssociates.map((associate) => (
                  <div
                    key={associate.id}
                    title={`${associate.first_name} ${associate.last_name}`}
                    className="d-flex align-items-center my-1 py-1 rounded"
                    onClick={() => handleSelectRemoveAssociate(associate.id)}
                    style={
                      selectedAssociates.some((id) => id === associate.id)
                        ? { backgroundColor: '#f1f1f1', cursor: 'pointer' }
                        : { cursor: 'pointer' }
                    }
                  >
                    <div className="me-2">
                      <img
                        className="rounded-circle border"
                        src={
                          associate.image
                            ? `${SERVER_URL}/${associate.image}`
                            : placeholderImage
                        }
                        alt="username-img"
                        style={{ height: '35px', width: '35px' }}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div>
                        {`${associate.first_name} ${associate.last_name}`
                          .length > 18
                          ? `${associate.first_name} ${associate.last_name}`.substr(
                              0,
                              18
                            ) + '...'
                          : `${associate.first_name} ${associate.last_name}`}
                      </div>
                      <div className="me-2">
                        {selectedAssociates.some(
                          (id) => id === associate.id
                        ) && <i className="fas fa-check text-muted" />}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <form onSubmit={(e) => handleSubmit(e)}>
            <div
              style={{
                position: 'fixed',
                bottom: 0,
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem',
              }}
              className="border-top bg-white d-flex align-items-center justify-content-end"
            >
              <button
                type="button"
                onClick={handleDiscard}
                className="btn btn-outline-brand adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Discard
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Save changes
              </button>
            </div>
          </form>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default withRouter(EditEvent);
